export default (function (node) {
  return node && node.ownerDocument || document;
});